import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Topbar from '../PulseSurvey/Topbar';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import Loader from '../../component/common/Loader';
import { shoorahBenefitsPageData as mainPageData } from '../../utils/pageContent';

const ViewBenefitsPage = () => {
  const pageData = mainPageData.viewBenefitsPageData;
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);


  const plansData = pageData.plansData;

  useEffect(() => {
    setPlans(plansData);
  }, []);


  return (
    <div className="relative lg:mb-[45px]">
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>

      <Topbar
        title={pageData.pageTitle}
        hasDesc={true}
        description={pageData.pageDescription}
        infoBtn={false}
      />


      <div className="flex flex-col w-full max-w-4xl mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        <div className="flex flex-col sm:flex-row mb-2 justify-between">
          <p className="text-xl font-medium text-gray-900 dark:text-white">{pageData.listOfBenefitsPlansTitle}</p>
        </div>

        {/* Loading state */}
        {loading && <p className="text-center my-4 text-gray-600 dark:text-gray-300">{pageData.laodingText}</p>}

        {/* Empty state */}
        {!loading && plans?.length === 0 && (
          <p className="text-center my-4 text-gray-500 dark:text-gray-400">
            {pageData.noBenefitsAvailableText}
          </p>
        )}

        {/* Plan list */}
        {!loading &&
          plans?.map((data, index) => (
            <div
              key={index}
              className="w-full mx-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden"
            >
              <div className="divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                <div className="hover:bg-gray-50 dark:hover:bg-gray-800 px-4 sm:px-6 py-3 sm:py-4">
                  <label className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
                    <div className="flex items-center w-full sm:w-auto">
                      <span className="font-medium text-gray-900 dark:text-white ml-2 sm:ml-3">
                        {data?.title}
                      </span>
                    </div>
                  </label>
                </div>

                <div className="px-8 py-4">
                  <p className="text-gray-700 dark:text-gray-300">{data?.description}</p>

                  {data?.planRequirements?.length > 0 && (
                    <div className="mt-4">
                      <h4 className="text-gray-900 dark:text-gray-300 font-medium mb-2">
                        {pageData.informationTitle}
                      </h4>
                      {data.planRequirements.map((text, idx) => (
                        <div key={idx} className="flex items-start my-3 text-xs sm:text-sm">
                          <img
                            src={instantSupportTick}
                            alt="Tick"
                            className="w-[20px] sm:w-[24px] h-[20px] sm:h-[24px] dark:invert mr-2"
                          />
                          <span className="text-[#606060] dark:text-gray-300">{text}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

        {/* Contact us button */}
        <button
          className="btn-primary w-full sm:w-[150px] mt-4"
          onClick={() => (window.location.href = 'mailto:info@shoorah.io')}
        >
          {pageData.contactUsBtnText}
        </button>
      </div>
    </div>
  );
};

export default ViewBenefitsPage;
